import twemoji from "twemoji";
import {isMobile} from "Core/screenSizes";

export const handleTwemoji = () => {
    if (!isMobile()) {
        twemoji.parse(document.body);
    }
};
